export enum FilterAction {
    setFranchise = 'setFranchise',
    setUf = 'setUf',
    setRegion = 'setRegion',
    setGroup = 'setGroup',
    setConsultant = 'setConsultant',
    setGoal = 'setGoal',
    setOverrun = 'setOverrun',
    setManager = 'setManager',
    setFilter = "setFilter",
    todayStatus = "todayStatus",
    noInfo = "noInfo",
    worseThanPastMonth = "worseThanPastMonth",
    missingDays = "missingDays",
    badStatus = "badStatus",
    badBalance = "badBalance",
    clearFilters = "clearFilters",
    setCategory = "setCategory",
    setCluster = "setCluster",
    setTagFilter = "setTagFilter"
 };
 